import "../../../../styles/page/order.scss";
import "../../../../styles/page/order.scss";

import { TitleTab, TitleTabs } from "../../../common/components/TitleTabs";

import AddRemoveField from "../../../common/components/AddRemoveField";
import AllProductPage from "../product/AllProductPage";
import EditListCart from "../List/EditListCart";
import { Localization } from "../../../common/util/localization.jsx";
import ProductPage from "../product/ProductPage";
import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../../../common/util/config";

class EditMyListPage extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            view: this.props.startView,
        };

        this.onClickSwapPage = this.onClickSwapPage.bind(this);
        this.calculateShoppingCartHeight = this.calculateShoppingCartHeight.bind(this);
    }

    UNSAFE_componentWillMount() {
        const {
            clearQuery,
            productLists,
            getMyLists,
            PrepareMyListForEdit,
            getBoughtProducts,
            getNewProducts,
        } = this.props;
        if( !productLists.customLists || productLists.customLists.length==0){
            getMyLists();
        }
        clearQuery();
        PrepareMyListForEdit();
        getBoughtProducts();
        getNewProducts();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if( this.state.view !== nextProps.startView) {
            this.setState({
                view: !nextProps.startView || nextProps.startView==="" ? "card" : nextProps.startView,
            });
        }
    }

    onClickSwapPage(event, view) {
        this.props.history.push(`/order/lists/edit/${this.props.listId}/${view?view:""}`);
    }

    calculateShoppingCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    render(){
        const {
            deviceType,
            localization,
            setOrderProductView,
            productView,
            addRemoveProductToActiveList,
            moveFromToInMyList,
            swapReplacedProductInMyList,
            changeCustomList,
            editQueryFilter,
            height,
            width,
            loadMoreSearchedProducts,
            productQuery,
            deliveryDates,
            productLists,
            editingList,
            UpdateMyList,
            deleteMyList,
            flowControl,
            listId,
            setModal,
            setDropDown,
            clearQuery,
        } = this.props;
        const shoppingCartHeight = this.calculateShoppingCartHeight();
        return this.state.view=="card" ? (
            <ProductPage
                deviceType={deviceType}
                localization={localization}
                setOrderProductView={setOrderProductView}
                productView={productView}
                activeList={editingList}
                addRemoveProductToActiveList={addRemoveProductToActiveList}
                editQueryFilter={editQueryFilter}
                filter={{
                    OnlyCampaigns: this.props.startView==="campaign",
                    OnlyNews: this.props.startView==="new",
                    OnlyLastSold: this.props.startView==="purchased",
                    ReturnTobacco: false,
                    ProductGroupId: null,
                    SupplierId: null,
                }}
                height={height}
                width={width}
                loadMoreSearchedProducts={loadMoreSearchedProducts}
                productQuery={productQuery}
                productLists={productLists}
                onClickShowProducts={this.onClickSwapPage}
                onClickSwapPage={this.onClickSwapPage}
                flowControl={flowControl}
                setModal={setModal}
                clearQuery={clearQuery}
                countingNode={<AddRemoveField/>}
                titleTabs={<TitleTabs>
                    <TitleTab label={localization.text("order","TitleTab","Products")} url={"/order/products"} deviceType={deviceType} />
                    <TitleTab label={localization.text("order","TitleTab","List")} url={"/order/lists"} deviceType={deviceType} />
                </TitleTabs>}
                cart={<EditListCart
                    localization={localization}
                    height={shoppingCartHeight}
                    width={width}
                    deviceType={deviceType}
                    editingList={editingList}
                    productLists={productLists}
                    addRemoveProductToTemporaryOrder={addRemoveProductToActiveList}
                    moveFromToInMyList={moveFromToInMyList}
                    swapReplacedProductInMyList={swapReplacedProductInMyList}
                    changeCustomList={changeCustomList}
                    deliveryDates={deliveryDates}
                    UpdateMyList={UpdateMyList}
                    deleteMyList={deleteMyList}
                    listId={listId}
                    setModal={setModal}
                />}
            />
        ) : (
            <AllProductPage
                deviceType={deviceType}
                localization={localization}
                setOrderProductView={setOrderProductView}
                productView={productView}
                activeList={editingList}
                addRemoveProductToActiveList={addRemoveProductToActiveList}
                editQueryFilter={editQueryFilter}
                filter={{
                    OnlyCampaigns: this.props.startView==="campaign",
                    OnlyNews: this.props.startView==="new",
                    OnlyLastSold: this.props.startView==="purchased",
                    ReturnTobacco: false,
                    ProductGroupId: null,
                    SupplierId: null,
                }}
                height={height}
                width={width}
                loadMoreSearchedProducts={loadMoreSearchedProducts}
                productQuery={productQuery}
                productLists={productLists}
                onClickShowProducts={this.onClickSwapPage}
                currentView={this.state.view}
                flowControl={flowControl}
                setModal={setModal}
                setDropDown={setDropDown}
                clearQuery={clearQuery}
                countingNode={<AddRemoveField/>}
                titleTabs={<TitleTabs>
                    <TitleTab label={localization.text("order","TitleTab","Products")} url={"/order/products"} deviceType={deviceType} />
                    <TitleTab label={localization.text("order","TitleTab","List")} url={"/order/lists"} deviceType={deviceType} />
                </TitleTabs>}
                cart={<EditListCart
                    localization={localization}
                    height={shoppingCartHeight}
                    width={width}
                    deviceType={deviceType}
                    editingList={editingList}
                    productLists={productLists}
                    addRemoveProductToTemporaryOrder={addRemoveProductToActiveList}
                    moveFromToInMyList={moveFromToInMyList}
                    swapReplacedProductInMyList={swapReplacedProductInMyList}
                    changeCustomList={changeCustomList}
                    deliveryDates={deliveryDates}
                    UpdateMyList={UpdateMyList}
                    deleteMyList={deleteMyList}
                    listId={listId}
                    setModal={setModal}
                />}
            />
        );
    }
}

EditMyListPage.propTypes = {
    //Required
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    setOrderProductView: PropTypes.func.isRequired,
    productView: PropTypes.object.isRequired,
    addRemoveProductToActiveList: PropTypes.func.isRequired,
    changeCustomList: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    loadMoreSearchedProducts: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    productLists: PropTypes.object.isRequired,
    getMyLists: PropTypes.func.isRequired,
    editingList: PropTypes.object.isRequired,
    UpdateMyList: PropTypes.func.isRequired,
    deleteMyList: PropTypes.func.isRequired,
    startView: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    moveFromToInMyList: PropTypes.func.isRequired,
    swapReplacedProductInMyList: PropTypes.func.isRequired,
    PrepareMyListForEdit: PropTypes.func.isRequired,
    flowControl: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    getBoughtProducts: PropTypes.func.isRequired,
    getNewProducts: PropTypes.func.isRequired,
    clearQuery: PropTypes.func.isRequired,
    //
    listId: PropTypes.number,
};

export default EditMyListPage;